import React from "react";
import { Design1, Design2, Design3, Design4, Design5, Wrapper } from "./style";
const DesignCom = () => {
  return (
    <Wrapper>
      {/* <Design1></Design1> */}
      {/* <Design2></Design2> */}
      {/* <Design3></Design3> */}
      <Design4></Design4>
      <Design5></Design5>
    </Wrapper>
  );
};

export default DesignCom;
